import type { Theme } from '@material-ui/core/styles';

// Gives the fields in the filter panel, including shared selectors
// like PortfolioSelector, one compact look without changing those components.
// Done through the theme because MUI class names in this app have generated
// suffixes, so they can't be targeted from SCSS. size="small" makes the inputs
// dense without the outer margins that margin="dense" adds.
export const filterPanelTheme = (outerTheme: Theme): Theme => ({
    ...outerTheme,
    props: {
        ...outerTheme.props,
        MuiFormControl: {
            ...outerTheme.props?.MuiFormControl,
            variant: 'outlined',
            size: 'small',
        },
    },
    overrides: {
        ...outerTheme.overrides,
        // Sentence case instead of upper case for buttons
        MuiButton: {
            ...outerTheme.overrides?.MuiButton,
            root: {
                ...outerTheme.overrides?.MuiButton?.root,
                textTransform: 'none',
            },
        },
        MuiOutlinedInput: {
            ...outerTheme.overrides?.MuiOutlinedInput,
            root: {
                ...outerTheme.overrides?.MuiOutlinedInput?.root,
                backgroundColor: outerTheme.palette.common.white,
            },
        },
    },
});

// The table sits in the same bordered card as the filters, so it gets no
// shadow of its own (the app theme gives every MUIDataTable one)
export const tableInCardTheme = (outerTheme: Theme): Theme => ({
    ...outerTheme,
    overrides: {
        ...outerTheme.overrides,
        MUIDataTable: {
            ...outerTheme.overrides?.MUIDataTable,
            paper: {
                ...outerTheme.overrides?.MUIDataTable?.paper,
                boxShadow: 'none',
                borderRadius: 0,
            },
        },
    },
});
